import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';

import './index.css';

const Footer = () => {

  return (

    <>

      <Navbar id="footer-fixo" key='md' expand='md' className="mb-3" fixed="bottom">
         <Container fluid>
          <Navbar.Brand>@Correios 2023</Navbar.Brand>
        </Container>        
      </Navbar>

    </>

  )
}

export default Footer